import { render, staticRenderFns } from "./productsInfo.vue?vue&type=template&id=96b56f18&"
import script from "./productsInfo.vue?vue&type=script&lang=js&"
export * from "./productsInfo.vue?vue&type=script&lang=js&"
import style0 from "./productsInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports